import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "transparent", "data-test-id", "type", "textAlign"];
import PropTypes from 'prop-types';
import Small from 'UIComponents/elements/Small';
import styled from 'styled-components';
import { GREAT_WHITE } from 'HubStyleTokens/colors';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const StyledBorder = styled.div.withConfig({
  displayName: "DashedLabel__StyledBorder",
  componentId: "sc-1tt5aaq-0"
})(["display:flex;flex-grow:1;border:solid 1px ", ";"], GREAT_WHITE);
const DashedLabel = _ref => {
  let {
      children,
      transparent,
      ['data-test-id']: data,
      type = 'help',
      textAlign = 'text-center'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsxs("div", Object.assign({
    className: 'm-y-2 display-flex align-end' + (transparent ? " justify-center" : ""),
    "data-test-id": data || 'dashed-label'
  }, rest, {
    children: [!transparent && /*#__PURE__*/_jsx(StyledBorder, {
      "data-test-id": "dash-left",
      className: "m-bottom-3"
    }), /*#__PURE__*/_jsx("div", {
      className: "max-100 p-x-4",
      children: /*#__PURE__*/_jsx(Small, {
        use: type,
        className: `m-bottom-1 align-center ${textAlign} word-break-break-word flex-column`,
        children: children
      })
    }), !transparent && /*#__PURE__*/_jsx(StyledBorder, {
      "data-test-id": "dash-right",
      className: "m-bottom-3"
    })]
  }));
};
DashedLabel.displayName = 'DashedLabel';
DashedLabel.propTypes = {
  children: PropTypes.node.isRequired,
  ['data-test-id']: PropTypes.string,
  textAlign: PropTypes.oneOf(['text-left', 'text-right', 'text-center']),
  transparent: PropTypes.bool,
  type: PropTypes.oneOf(['error', 'help', 'success'])
};
export default DashedLabel;